import styled from 'styled-components';

import { Row } from '..';

export const StaleField = styled(Row)`
  margin: 16px 0;
  width: 100%;
`;
